// SPDX-License-Identifier: AGPL-3.0-or-later
import {type CloudAttachment, CloudUpload, type MessageUpload} from '@app/features/messaging/upload/CloudUpload';
import {useEffect, useState} from 'react';
export function useTextareaAttachments(channelId: string): ReadonlyArray<CloudAttachment> {
	const [attachments, setAttachments] = useState<ReadonlyArray<CloudAttachment>>(() =>
		CloudUpload.getTextareaAttachments(channelId),
	);
	useEffect(() => {
		const subscription = CloudUpload.attachments$(channelId).subscribe(setAttachments);
		return () => subscription.unsubscribe();
	}, [channelId]);
	return attachments;
}
export function useMessageUpload(nonce: string): MessageUpload | null {
	const [upload, setUpload] = useState<MessageUpload | null>(() =>
		nonce ? CloudUpload.getMessageUpload(nonce) : null,
	);
	useEffect(() => {
		if (!nonce) {
			setUpload(null);
			return;
		}
		const subscription = CloudUpload.messageUpload$(nonce).subscribe((next) => {
			setUpload(next);
		});
		return () => subscription.unsubscribe();
	}, [nonce]);
	return upload;
}
